import { Injectable } from "@angular/core";

/**
 * Centraliza o acesso ao objeto global localStorage.
 */
@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    
    /**
     * Retorna o id, armazenado no localStorage, do usuário conectado.
     * @returns id do usuário conectado
     */
    getUserId() {
        return JSON.parse(localStorage.getItem('userInfo')).id;
    }
}
